export default [
  {
    path: '/pengajuan-kajietik/baru',
    name: 'pengajuan-kajietik-baru',
    component: () => import('@/views/pages/pengajuan-kajietik-baru/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-kajietik',
      action: 'create',
    },
  },
  {
    path: '/pengajuan-kajietik/edit/:uuid',
    name: 'pengajuan-kajietik-edit',
    component: () => import('@/views/pages/pengajuan-kajietik/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-kajietik',
      action: 'edit',
    },
  },
  {
    path: '/pengajuan-kajietik/readonly/:uuid',
    name: 'pengajuan-kajietik-readonly',
    component: () => import('@/views/pages/pengajuan-kajietik-readonly/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-kajietik',
      action: 'readonly',
    },
  },
  {
    path: '/daftar-kajietik',
    name: 'list-kajietik',
    component: () => import('@/views/pages/daftar-kajietik/list/List.vue'),
    meta: {
      resource: 'list-kajietik',
      action: 'read',
    },
  },
  {
    path: '/jadwal-kajietik',
    name: 'jadwal-kajietik',
    component: () => import('@/views/pages/jadwal-kajietik/list/List.vue'),
    meta: {
      resource: 'jadwal-kajietik',
      action: 'read',
    },
  },
  {
    path: '/hasil-kajietik',
    name: 'hasil-kajietik',
    component: () => import('@/views/pages/hasil-kajietik/list/List.vue'),
    meta: {
      resource: 'hasil-kajietik',
      action: 'read',
    },
  },
  {
    path: '/hasil-kajietik-edit/:uuid',
    name: 'hasil-kajietik-edit',
    component: () => import('@/views/pages/hasil-kajietik/tab/Tab.vue'),
    meta: {
      resource: 'hasil-kajietik',
      action: 'edit',
    },
  },
  {
    path: '/pengguna',
    name: 'pengguna',
    component: () => import('@/views/pages/pengguna/list/List.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/pengguna-daftar-baru',
    name: 'pengguna-daftar-baru',
    component: () => import('@/views/pages/pengguna-daftar-baru/list/List.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/pengguna-edit/:id',
    name: 'pengguna-edit',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/hak-akses',
    name: 'hak-akses',
    component: () => import('@/views/pages/rules/list/List.vue'),
    meta: {
      resource: 'hak-akses',
      action: 'read',
    },
  },
  {
    path: '/hak-akses/edit/:id',
    name: 'hak-akses-edit',
    component: () => import('@/views/pages/rules/edit/Edit.vue'),
    meta: {
      resource: 'hak-akses',
      action: 'edit',
    },
  },
  {
    path: '/dosen',
    name: 'dosen',
    component: () => import('@/views/pages/dosen/list/List.vue'),
    meta: {
      resource: 'dosen',
      action: 'read',
    },
  },
  {
    path: '/dosen/:uuid',
    name: 'dosen-edit',
    component: () => import('@/views/pages/dosen/edit/Edit.vue'),
    meta: {
      resource: 'dosen',
      action: 'read',
    },
  },
  {
    path: '/jenjang',
    name: 'jenjang',
    component: () => import('@/views/pages/jenjang/list/List.vue'),
    meta: {
      resource: 'jenjang',
      action: 'read',
    },
  },
  {
    path: '/jenjang/:uuid',
    name: 'jenjang-edit',
    component: () => import('@/views/pages/jenjang/edit/Edit.vue'),
    meta: {
      resource: 'jenjang',
      action: 'read',
    },
  },
  {
    path: '/prodi',
    name: 'prodi',
    component: () => import('@/views/pages/prodi/list/List.vue'),
    meta: {
      resource: 'prodi',
      action: 'read',
    },
  },
  {
    path: '/prodi/:uuid',
    name: 'prodi-edit',
    component: () => import('@/views/pages/prodi/edit/Edit.vue'),
    meta: {
      resource: 'prodi',
      action: 'read',
    },
  },
  {
    path: '/peminatan',
    name: 'peminatan',
    component: () => import('@/views/pages/peminatan/list/List.vue'),
    meta: {
      resource: 'peminatan',
      action: 'read',
    },
  },
  {
    path: '/peminatan/:uuid',
    name: 'peminatan-edit',
    component: () => import('@/views/pages/peminatan/edit/Edit.vue'),
    meta: {
      resource: 'peminatan',
      action: 'read',
    },
  },
  {
    path: '/program',
    name: 'program',
    component: () => import('@/views/pages/program/list/List.vue'),
    meta: {
      resource: 'program',
      action: 'read',
    },
  },
  {
    path: '/program/:uuid',
    name: 'program-edit',
    component: () => import('@/views/pages/program/edit/Edit.vue'),
    meta: {
      resource: 'program',
      action: 'read',
    },
  },
  {
    path: '/ruangan',
    name: 'ruangan',
    component: () => import('@/views/pages/ruangan/list/List.vue'),
    meta: {
      resource: 'ruangan',
      action: 'read',
    },
  },
  {
    path: '/ruangan/:uuid',
    name: 'ruangan-edit',
    component: () => import('@/views/pages/ruangan/edit/Edit.vue'),
    meta: {
      resource: 'ruangan',
      action: 'read',
    },
  },
  {
    path: '/waktu-ujian',
    name: 'waktu-ujian',
    component: () => import('@/views/pages/waktu-ujian/list/List.vue'),
    meta: {
      resource: 'waktu-ujian',
      action: 'read',
    },
  },
  {
    path: '/waktu-ujian/:uuid',
    name: 'waktu-ujian-edit',
    component: () => import('@/views/pages/waktu-ujian/edit/Edit.vue'),
    meta: {
      resource: 'waktu-ujian',
      action: 'read',
    },
  },
  {
    path: '/status-hasil-kajietik',
    name: 'status-hasil-kajietik',
    component: () => import('@/views/pages/status-hasil-kajietik/list/List.vue'),
    meta: {
      resource: 'status-hasil-kajietik',
      action: 'read',
    },
  },
  {
    path: '/status-hasil-kajietik/:uuid',
    name: 'status-hasil-kajietik-edit',
    component: () => import('@/views/pages/status-hasil-kajietik/edit/Edit.vue'),
    meta: {
      resource: 'status-hasil-kajietik',
      action: 'read',
    },
  },
  {
    path: '/status-jadwal-kajietik',
    name: 'status-jadwal-kajietik',
    component: () => import('@/views/pages/status-jadwal-kajietik/list/List.vue'),
    meta: {
      resource: 'status-jadwal-kajietik',
      action: 'read',
    },
  },
  {
    path: '/status-jadwal-kajietik/:uuid',
    name: 'status-jadwal-kajietik-edit',
    component: () => import('@/views/pages/status-jadwal-kajietik/edit/Edit.vue'),
    meta: {
      resource: 'status-jadwal-kajietik',
      action: 'read',
    },
  },
  {
    path: '/status-pengajuan-kajietik',
    name: 'status-pengajuan-kajietik',
    component: () => import('@/views/pages/status-pengajuan-kajietik/list/List.vue'),
    meta: {
      resource: 'status-pengajuan-kajietik',
      action: 'read',
    },
  },
  {
    path: '/status-pengajuan-kajietik/:uuid',
    name: 'status-pengajuan-kajietik-edit',
    component: () => import('@/views/pages/status-pengajuan-kajietik/edit/Edit.vue'),
    meta: {
      resource: 'status-pengajuan-kajietik',
      action: 'read',
    },
  },
  {
    path: '/proses-kajietik',
    name: 'proses-kajietik',
    component: () => import('@/views/pages/proses-kajietik/list/List.vue'),
    meta: {
      resource: 'proses-kajietik',
      action: 'read',
    },
  },
  {
    path: '/proses-kajietik/:uuid',
    name: 'proses-kajietik-edit',
    component: () => import('@/views/pages/proses-kajietik/edit/Edit.vue'),
    meta: {
      resource: 'proses-kajietik',
      action: 'read',
    },
  },
  {
    path: '/sync-dosen',
    name: 'sync-dosen',
    component: () => import('@/views/pages/sync-dosen/list/List.vue'),
    meta: {
      resource: 'sync-dosen',
      action: 'read',
    },
  },
  {
    path: '/account/reset/:token',
    name: 'reset-account',
    component: () => import('@/views/pages/reset-akun/edit/Edit.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'readonly',
    },
  },
  // {
  //   path: '/apps/calendar',
  //   name: 'apps-calendar',
  //   component: () => import('@/views/apps/calendar/Calendar.vue'),
  // },

  // // *===============================================---*
  // // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/email',
  //   name: 'apps-email',
  //   component: () => import('@/views/apps/email/Email.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'email-application',
  //   },
  // },
  // {
  //   path: '/apps/email/:folder',
  //   name: 'apps-email-folder',
  //   component: () => import('@/views/apps/email/Email.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'email-application',
  //     navActiveLink: 'apps-email',
  //   },
  //   beforeEnter(to, _, next) {
  //     if (['sent', 'draft', 'starred', 'spam', 'trash'].includes(to.params.folder)) next()
  //     else next({ name: 'error-404' })
  //   },
  // },
  // {
  //   path: '/apps/email/label/:label',
  //   name: 'apps-email-label',
  //   component: () => import('@/views/apps/email/Email.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'email-application',
  //     navActiveLink: 'apps-email',
  //   },
  //   beforeEnter(to, _, next) {
  //     if (['personal', 'company', 'important', 'private'].includes(to.params.label)) next()
  //     else next({ name: 'error-404' })
  //   },
  // },

  // // *===============================================---*
  // // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/todo',
  //   name: 'apps-todo',
  //   component: () => import('@/views/apps/todo/Todo.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'todo-application',
  //   },
  // },
  // {
  //   path: '/apps/todo/:filter',
  //   name: 'apps-todo-filter',
  //   component: () => import('@/views/apps/todo/Todo.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'todo-application',
  //     navActiveLink: 'apps-todo',
  //   },
  //   beforeEnter(to, _, next) {
  //     if (['important', 'completed', 'deleted'].includes(to.params.filter)) next()
  //     else next({ name: 'error-404' })
  //   },
  // },
  // {
  //   path: '/apps/todo/tag/:tag',
  //   name: 'apps-todo-tag',
  //   component: () => import('@/views/apps/todo/Todo.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'todo-application',
  //     navActiveLink: 'apps-todo',
  //   },
  //   beforeEnter(to, _, next) {
  //     if (['team', 'low', 'medium', 'high', 'update'].includes(to.params.tag)) next()
  //     else next({ name: 'error-404' })
  //   },
  // },

  // // *===============================================---*
  // // *--------- CHAT  ---------------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/chat',
  //   name: 'apps-chat',
  //   component: () => import('@/views/apps/chat/Chat.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'chat-application',
  //   },
  // },

  // // *===============================================---*
  // // *--------- ECOMMERCE  ---------------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/e-commerce/shop',
  //   name: 'apps-e-commerce-shop',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left-detached',
  //     contentClass: 'ecommerce-application',
  //     pageTitle: 'Shop',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Shop',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/e-commerce/wishlist',
  //   name: 'apps-e-commerce-wishlist',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue'),
  //   meta: {
  //     pageTitle: 'Wishlist',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Wishlist',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/e-commerce/checkout',
  //   name: 'apps-e-commerce-checkout',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue'),
  //   meta: {
  //     pageTitle: 'Checkout',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Checkout',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/e-commerce/:slug',
  //   name: 'apps-e-commerce-product-details',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
  //   meta: {
  //     pageTitle: 'Product Details',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Shop',
  //         active: true,
  //       },
  //       {
  //         text: 'Product Details',
  //         active: true,
  //       },
  //     ],
  //   },
  // },

  // // *===============================================---*
  // // *--------- USER ---- ---------------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/users/list',
  //   name: 'apps-users-list',
  //   component: () => import('@/views/apps/user/users-list/UsersList.vue'),
  // },
  // {
  //   path: '/apps/users/view/:id',
  //   name: 'apps-users-view',
  //   component: () => import('@/views/apps/user/users-view/UsersView.vue'),
  // },
  // {
  //   path: '/apps/users/edit/:id',
  //   name: 'apps-users-edit',
  //   component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
  // },

  // // Invoice
  // {
  //   path: '/apps/invoice/list',
  //   name: 'apps-invoice-list',
  //   component: () => import('@/views/apps/invoice/invoice-list/InvoiceList.vue'),
  // },
  // {
  //   path: '/apps/invoice/preview/:id',
  //   name: 'apps-invoice-preview',
  //   component: () => import('@/views/apps/invoice/invoice-preview/InvoicePreview.vue'),
  // },
  // {
  //   path: '/apps/invoice/add/',
  //   name: 'apps-invoice-add',
  //   component: () => import('@/views/apps/invoice/invoice-add/InvoiceAdd.vue'),
  // },
  // {
  //   path: '/apps/invoice/edit/:id',
  //   name: 'apps-invoice-edit',
  //   component: () => import('@/views/apps/invoice/invoice-edit/InvoiceEdit.vue'),
  // },
]
